import React from 'react';
import Preloader from '../components/Preloader';
import CompanyForm from '../components/CompanyForm';

const Business = () => {
  return (
    <div className="industify_fn_wrapper_all" data-nav-skin="transdark">
      <div className="industify_fn_wrapper">
        <Preloader />
        <CompanyForm />
      </div>
    </div>
  );
};

export default Business;